import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col } from "react-bootstrap";

import { Comparison, FilterComponent } from "../../Shared";
import { Common, DefaultData, BPComparison, NavigationBar } from "../../../helper";
import * as bigPictureApi from "../../../api/bigPictureApi";
import { isEmptyArray, isEmptyObject } from "../../../util";

import updateReportImage from "../../../assets/images/BPupdateReportImage.svg"
import { setSelect } from "../../../store/stylesSlice";

const FilterComparisonMain = (props) => {
  const { setSubjects, number, setIsLoading, isGLD, setSelectedClassName, selectedBaseLine, setUpComing, isSubject, setMainPage } = props;

  const [filterGroup, setFilterGroup] = useState(DefaultData.FilterComponent);
  const [disableUpdate, setDisableUpdate] = useState(false);
  const [mainFilter, setMainFilter] = useState();
  const [compFilter, setCompFilter] = useState();
  const [count, setCount] = useState(0);
  const [compSelected, setCompSelected] = useState();
  // const [finalProgressReport, setFinalProgressReport] = useState();
  const dispatch = useDispatch();

  const [pupilProgress, setPupilProgress] = useState(DefaultData.FilterComponent);
  let selectedComparison = useSelector((state) => state.pupilProgress.BPComparisonSelect)
  const selectedPupilFilter = useSelector((state) => state.pupilProgress.pupilFilter.info)

  dispatch(setSelect(NavigationBar.BigPicture))

  const commonFilter = (getProgress) => {
    // setFinalProgressReport(getProgress);
    getProgress = (compSelected === BPComparison.None)
      ? getProgress.Items
      : getProgress.Items.map(sub => {
        let subArray = sub[Object.keys(sub)[0]];
        let GLD_KS1;
        return {
          [Object.keys(sub)[0]]: subArray.filter(ele => {
            switch (compSelected) {
            case BPComparison.Gender:
              return ele.name == BPComparison.ALL || (ele.name.includes(BPComparison.UNSPECIFIED_GENDER)) || (ele.name.includes(BPComparison.MALE)) || (ele.name.includes(BPComparison.FEMALE));

            case Common.Year.toUpperCase():
              return ele.name == BPComparison.ALL || ele.name.includes(Common.Year.toUpperCase());

            case BPComparison.None:
              return ele.name == BPComparison.ALL || ele.name.includes(BPComparison.None);

            case BPComparison.PP:
              return ele.name == BPComparison.ALL || ele.name.includes(BPComparison.PUPIL_PREMIUM) || ele.name.includes(BPComparison.FSM) || ele.name.includes(BPComparison.LEA);

            case BPComparison.EAL:
              return ele.name == BPComparison.ALL || ele.name.includes(BPComparison.EAL);

            case BPComparison.SEND:
              return ele.name == BPComparison.ALL || ele.name.includes(BPComparison.SEND) || ele.name.includes(BPComparison.EHCP);

            case BPComparison.GLD:
              GLD_KS1 = BPComparison.GLD.split("/");
              return ele.name == BPComparison.ALL || (ele.name.includes(GLD_KS1[0])) || (ele.name.includes(GLD_KS1[1]));

            case BPComparison.Ethnicity:
              GLD_KS1 = BPComparison.GLD.split("/");
              return ele.name == BPComparison.ALL || !ele.name.includes(BPComparison.MALE) && !ele.name.includes(BPComparison.FEMALE) && !ele.name.includes(BPComparison.UNSPECIFIED_GENDER) && !ele.name.includes(Common.Year.toUpperCase()) && !ele.name.includes(BPComparison.None) && !ele.name.includes(BPComparison.PUPIL_PREMIUM) && !ele.name.includes(BPComparison.FSM) && !ele.name.includes(BPComparison.LEA) && !ele.name.includes(BPComparison.EAL) && !ele.name.includes(BPComparison.SEND) && !ele.name.includes(BPComparison.EHCP) && !(ele.name.includes(GLD_KS1[0])) && !(ele.name.includes(GLD_KS1[1])) && !ele.name.includes(BPComparison.ALL) && !ele.name.includes(BPComparison.Passed.toUpperCase()) && !ele.name.includes(BPComparison.SERVICECHILDREN.toUpperCase());

            default:
              return getProgress.Items;
            }
          }),

        };
      });
    setSubjects(getProgress)
    setIsLoading(false)
  }

  const getEOYP = async () => {
    setIsLoading(true)
    let comparison = selectedComparison === BPComparison.None ? BPComparison.Year?.toLowerCase() : selectedComparison === BPComparison.GLD ? Common.GLD?.toLowerCase() : selectedComparison === undefined ? BPComparison.Year?.toLowerCase() : selectedComparison?.toLowerCase();
    let getProgress = number === 1 ? (await bigPictureApi.getAllEOYP(pupilProgress)) : number === 5 ? (await bigPictureApi.getProgress({ ...pupilProgress, baseline: selectedBaseLine })) : number === 2 ? (await bigPictureApi.getPredictedPassRateByYear({ ...pupilProgress, comparison })) :
      number === 4 ? (selectedComparison === BPComparison.None || selectedComparison === undefined) ? await bigPictureApi.getDemographics(pupilProgress) : selectedComparison === BPComparison.PP ? await bigPictureApi.getDemographicsByPupilPremium(pupilProgress) : selectedComparison === BPComparison.Gender ? await bigPictureApi.getDemographicsByGender(pupilProgress) :
        selectedComparison === BPComparison.EAL ? await bigPictureApi.getDemographicsByEAL(pupilProgress) : selectedComparison === BPComparison.GLD ? await bigPictureApi.getDemographicsByGld(pupilProgress) :
          selectedComparison === BPComparison.SEND ? await bigPictureApi.getDemographicsBySend(pupilProgress) : selectedComparison === BPComparison.Year ? await bigPictureApi.getDemographicsByYear({...pupilProgress,pupilYear:DefaultData.FilterComponent.pupilYear}) : "" : "";
    setMainFilter(pupilProgress);
    setCompFilter(compSelected ? compSelected : BPComparison.None);
    if (!isEmptyArray(getProgress.Items) || !isEmptyObject(getProgress.Items)) {
      switch (number) {
      case 1:
      case 5: commonFilter(getProgress);
        break;
      case 2: setSubjects(getProgress?.Items[0])
        setIsLoading(false)
        break;
      case 4: selectedComparison == BPComparison.None ? setMainPage(true) : setMainPage(false)
        setSubjects(getProgress?.Items)
        setIsLoading(false)
        break;
      default:
        break;
      }
    }
    setDisableUpdate(false)
  }

  const areFilterObjectsEqual = (obj1, obj2) => {
    if (compFilter === selectedComparison) {
      if (!isEmptyObject(obj1) && !isEmptyObject(obj2)) {
        const keys1 = Object.keys(obj1);
        const keys2 = Object.keys(obj2);

        if (keys1.length === keys2.length) {
          for (const key of keys1) {
            if (key !== BPComparison.pupilYear && key !== BPComparison.SUBJECTNAME) {
              // Exclude pupilYear from direct comparison
              if (obj1[key] !== obj2[key]) {
                return true;
              }
            } else if (key === BPComparison.pupilYear) {
              // Array comparison for pupilYear
              if (!(obj1[key].length === obj2[key].length && obj1[key].every((value, index) => value === obj2[key][index]))) {
                return !(obj1[key].length === obj2[key].length && obj1[key].every((value, index) => value === obj2[key][index]));
              }
            } else if (BPComparison.SUBJECTNAME) {
              if (obj1[key] !== obj2[key]) {
                return true;
              }
            }
          }
          return false;
        }
      } else {
        return false;
      }
    } else {
      return true;
    }
  };

  const checkAndRenderUI = () => {
    // let checkObjects = compFilter != selectedComparison;
    switch (number) {
    case 1:
    case 5: getEOYP();
      break;
    case 2: case 4: getEOYP();
      break;
    default:
      break;
    }

  }

  useEffect(() => {
    if (count !== 0) {
      setDisableUpdate(areFilterObjectsEqual(mainFilter, selectedPupilFilter));
    } else if (count === 0 && (number === 2 || number===4)) {
      selectedComparison = BPComparison.None;
      getEOYP();
    }
    setCompSelected(selectedComparison !== undefined ? selectedComparison : BPComparison.None)
    setPupilProgress(selectedPupilFilter)

    // This For Ethnicity of PPR is not yet Cleared by Client till clarification it is here
    if ((number === 2 || number===4) && selectedComparison === BPComparison.Ethnicity) {
      setDisableUpdate(false);
      setUpComing(true);
    } else if ((number === 2 || number===4) && selectedComparison !== BPComparison.Ethnicity) {
      setUpComing(false);
    }
  }, [selectedPupilFilter, selectedComparison])

  useEffect(() => {
    getEOYP();
    setMainFilter(pupilProgress);
    setCompFilter(compSelected ? compSelected : BPComparison.None);
    setCount(1)
  }, [selectedBaseLine])

  return (
    <Row className="EOYP-comparison-main">
      <Col md={4} lg={3} className="comparison-main">
        <Comparison isGLD={isGLD} />
      </Col>
      <Col md={8} lg={9} className="filter-main" >
        <FilterComponent filterGroup={filterGroup} setFilterGroup={setFilterGroup} setSelectedClassName={setSelectedClassName} isSubject={isSubject} disableUpdate={disableUpdate}/>
      </Col>
      {disableUpdate && <div className="generateButtonMain"><button className="generateButton d-flex align-items-center justify-content-around" onClick={() => checkAndRenderUI()} ><span className="title">{Common.UpdateReport}</span><img src={updateReportImage} alt=""></img></button></div>}
    </Row>
  )
}

export { FilterComparisonMain }